import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  time_from: d.startOf('day').format(),
  time_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change, parkingId }) => {
  const { t } = useTranslation();

  const filters = [
    // { type: 'dict', dict: 'calls.type' },
    { type: 'dict', dict: 'calls.status', multiple: true },
    { type: 'doubledate', name: 'time', title: t('filter.Начало события'), change },
    { type: 'duration', name: 'dur', title: t('filter.Длительность'), w: 110 },
    { type: 'source', multiple: true, exclude: ['rack.server', 'rack.cashbox'], parkingId },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'callsFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
